/**
 * Judge.me helpers for product + all-reviews pages.
 * All-reviews uses legacy .jdgm-all-reviews-widget — keep init minimal to avoid observer loops.
 */
let bossJudgemeInitialized = false;
let bossAllReviewsReadyApplied = false;
let bossFormScriptsPreloaded = false;

function bossAllReviewsPage() {
  return document.querySelector('.boss-shop-reviews .jdgm-all-reviews-page, #judgeme_all_reviews .jdgm-all-reviews-page');
}

function bossAllReviewsWidget() {
  return document.querySelector('.boss-shop-reviews .jdgm-all-reviews-widget, #judgeme_all_reviews .jdgm-all-reviews-widget');
}

function bossEnsureAllReviewsStructure() {
  const page = bossAllReviewsPage();
  if (!page || page.querySelector('.jdgm-all-reviews-widget')) return;

  const widget = document.createElement('div');
  widget.className = 'jdgm-all-reviews-widget';
  widget.setAttribute('data-class-prefix', 'jdgm-all-reviews');

  const tempStyle = page.querySelector('.jdgm-temporary-style');
  const header = page.querySelector('.jdgm-all-reviews__header');
  const body = page.querySelector('.jdgm-all-reviews__body') || document.createElement('div');

  if (!body.classList.contains('jdgm-all-reviews__body')) {
    body.className = 'jdgm-all-reviews__body';
    page.querySelectorAll(':scope > .jdgm-rev').forEach((review) => {
      body.appendChild(review);
    });
  }

  if (tempStyle) widget.appendChild(tempStyle);
  if (header) widget.appendChild(header);
  widget.appendChild(body);
  page.appendChild(widget);
}

function bossIsAllReviewsReady() {
  const widget = bossAllReviewsWidget();
  if (!widget) return false;

  return (
    widget.classList.contains('jdgm--done-setup') ||
    widget.classList.contains('jdgm--done-setup-widget') ||
    Boolean(widget.querySelector('.jdgm-subtab'))
  );
}

function bossPreloadReviewFormScriptsOnce() {
  if (bossFormScriptsPreloaded || typeof window.jdgm?.loadScript !== 'function') return;

  const host = window.jdgm.CDN_HOST || 'https://cdnwidget.judge.me/';
  const formJs = `${host}widget/form.js`;

  if (window.jdgm.loadScript.requestedUrls?.indexOf(formJs) >= 0) {
    bossFormScriptsPreloaded = true;
    return;
  }

  bossFormScriptsPreloaded = true;
  window.jdgm.loadScript(`${host}widget/write_review_modal.js`);
  window.jdgm.loadScript(formJs);

  if (typeof window.jdgm.loadCSS === 'function' && typeof window.jdgm.widgetPath === 'function') {
    window.jdgm.loadCSS(window.jdgm.widgetPath('form.css'));
  }
}

function bossEnsureReviewVerifiedBadge(review) {
  if (!review || review.dataset.bossVerifiedBadgeApplied === 'true') return;

  review.setAttribute('data-verified-buyer', 'true');
  review.dataset.bossVerifiedBadgeApplied = 'true';

  const badgeWrapper = review.querySelector('.jdgm-rev__buyer-badge-wrapper');
  const badges = [...review.querySelectorAll('.jdgm-rev__buyer-badge')];

  if (badges.length > 1) {
    const preferred = badges.find((badge) => badgeWrapper?.contains(badge)) || badges[0];
    badges.forEach((badge) => {
      if (badge !== preferred) badge.remove();
    });
  }

  let badge = review.querySelector('.jdgm-rev__buyer-badge');

  if (!badge) {
    badge = document.createElement('span');
    badge.className = 'jdgm-rev__buyer-badge';

    if (badgeWrapper) {
      badgeWrapper.appendChild(badge);
    } else {
      const authorWrapper = review.querySelector('.jdgm-rev__author-wrapper');
      if (authorWrapper) {
        authorWrapper.appendChild(badge);
      } else {
        review.querySelector('.jdgm-rev__header')?.appendChild(badge);
      }
    }
  } else if (badgeWrapper && !badgeWrapper.contains(badge)) {
    badgeWrapper.appendChild(badge);
  }

  // Judge.me prints the label via ::before — text content would duplicate it.
  badge.textContent = '';
  badge.hidden = false;
  badge.style.removeProperty('display');
}

function bossApplyShopReviewVerifiedBadges() {
  document.querySelectorAll('.boss-shop-reviews .jdgm-rev').forEach(bossEnsureReviewVerifiedBadge);
}

let bossVerifiedBadgeObserver = null;

function bossObserveShopReviewVerifiedBadges() {
  if (!document.querySelector('.boss-shop-reviews')) return;

  bossApplyShopReviewVerifiedBadges();

  if (bossVerifiedBadgeObserver) return;

  const target =
    document.querySelector('.boss-shop-reviews .jdgm-all-reviews__body') ||
    document.querySelector('.boss-shop-reviews .boss-judgeme-reviews') ||
    document.querySelector('.boss-shop-reviews');

  if (!target) return;

  bossVerifiedBadgeObserver = new MutationObserver(() => {
    bossApplyShopReviewVerifiedBadges();
  });

  bossVerifiedBadgeObserver.observe(target, { childList: true, subtree: true });
}

function bossTeardownVerifiedBadgeObserver() {
  bossVerifiedBadgeObserver?.disconnect();
  bossVerifiedBadgeObserver = null;
}

function bossApplyAllReviewsReadyOnce() {
  if (bossAllReviewsReadyApplied || !bossIsAllReviewsReady()) return;

  const widget = bossAllReviewsWidget();
  if (!widget) return;

  bossAllReviewsReadyApplied = true;

  widget.querySelectorAll('.jdgm-temporary-style').forEach((styleEl) => {
    styleEl.remove();
  });
  widget.style.removeProperty('display');

  const link = widget.querySelector('.jdgm-all-reviews__header .jdgm-write-rev-link');
  if (link) {
    const label = window.jdgmSettings?.widget_write_a_store_review_text || 'Write a Store Review';
    link.textContent = label;
    link.style.removeProperty('display');
    link.removeAttribute('aria-hidden');
  }

  document.querySelectorAll('.boss-shop-reviews__store-review-btn, [data-boss-store-review]').forEach((el) => {
    el.remove();
  });

  bossPreloadReviewFormScriptsOnce();
  bossObserveShopReviewVerifiedBadges();
}

function bossLoadJudgemeWidgetsOnce() {
  if (typeof window.jdgm === 'undefined' || typeof window.jdgm.loadWidgets !== 'function') {
    return false;
  }

  bossEnsureAllReviewsStructure();

  if (!bossJudgemeInitialized) {
    window.jdgm.loadWidgets();
    bossJudgemeInitialized = true;
  }

  return true;
}

function bossScheduleJudgemeLoad() {
  let attempts = 0;
  const maxAttempts = 50;

  const tryLoad = () => {
    attempts += 1;

    if (bossLoadJudgemeWidgetsOnce()) {
      bossApplyAllReviewsReadyOnce();

      if (!bossAllReviewsReadyApplied && attempts < maxAttempts) {
        window.setTimeout(tryLoad, 500);
      }

      return;
    }

    if (attempts >= maxAttempts) return;
    window.setTimeout(tryLoad, 250);
  };

  tryLoad();
}

function bossInitJudgeme() {
  bossEnsureAllReviewsStructure();
  bossScheduleJudgemeLoad();
  bossObserveShopReviewVerifiedBadges();
}

function bossResetJudgemeInit() {
  bossJudgemeInitialized = false;
  bossAllReviewsReadyApplied = false;
  bossFormScriptsPreloaded = false;
  bossTeardownVerifiedBadgeObserver();
  document.querySelectorAll('.boss-shop-reviews .jdgm-rev[data-boss-verified-badge-applied]').forEach((review) => {
    delete review.dataset.bossVerifiedBadgeApplied;
  });
  bossInitJudgeme();
}

function bossHandleJudgemeReadyEvent() {
  bossApplyAllReviewsReadyOnce();
  bossApplyShopReviewVerifiedBadges();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bossInitJudgeme);
} else {
  bossInitJudgeme();
}

document.addEventListener('jdgm.doneSetup', bossHandleJudgemeReadyEvent);
document.addEventListener('shopify:section:load', bossResetJudgemeInit);
